<script setup>
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useMapGetter } from 'dashboard/composables/store';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['sendMessage', 'resetTemplate']);

// GK-HUB: PIX account defaults for ORDER_DETAILS buttons
const currentAccount = useMapGetter('getCurrentAccount');

const handleSendMessage = payload => {
  // GK-HUB: enrich ORDER_DETAILS buttons with account-level PIX merchant/key/key_type
  const buttons = payload?.templateParams?.processed_params?.buttons;
  if (Array.isArray(buttons)) {
    const attrs = currentAccount.value?.custom_attributes || {};
    buttons.forEach(btn => {
      if (btn?.type === 'order_details' && btn.order_details) {
        btn.order_details.merchant_name = attrs.pix_merchant_name || '';
        btn.order_details.pix_key = attrs.pix_key || '';
        btn.order_details.key_type = attrs.pix_key_type || 'CNPJ';
      }
    });
  }
  // GK-HUB: end enrichment
  emit('sendMessage', payload);
};

const handleResetTemplate = () => {
  emit('resetTemplate');
};
</script>

<template>
  <div class="w-full">
    <WhatsAppTemplateParser
      :template="template"
      @send-message="handleSendMessage"
      @reset-template="handleResetTemplate"
    >
      <template #actions="{ sendMessage, resetTemplate, disabled }">
        <footer class="flex gap-2 justify-end">
          <NextButton
            faded
            slate
            type="reset"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.GO_BACK_LABEL')"
            @click="resetTemplate"
          />
          <NextButton
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            :disabled="disabled"
            @click="sendMessage"
          />
        </footer>
      </template>
    </WhatsAppTemplateParser>
  </div>
</template>
